<script>
import { v4 as uuid } from 'uuid';
import { makeID } from '../../Modules/Strings.js';
import tippy from 'tippy.js';

export default {
  props: {
    icon: String,
    tooltip: {
      type: String,
      default: '',
    },
    size: String,
  },

  methods: {},

  created() {
    this.id = makeID(10);
  },
  mounted() {
    if (this.tooltip.length > 0) {
      let icon = tippy('#' + this.iconId, {
        content: this.tooltip,
      });
    }
  },

  data() {
    return {
      id: null,
    };
  },

  computed: {
    iconId() {
      return 'icon-' + this.id;
    },

    iconsized() {
      let iconClass = this.icon;
      if (this.size !== undefined && this.size.length > 0) {
        iconClass += ' fa-' + this.size;
      }
      return iconClass;
    },

    dynamicStyle() {
      return {
        cursor: this.$attrs && this.$attrs.onClick ? 'pointer' : 'auto',
      };
    },
  },
};
</script>

<template>
  <i
    :class="iconsized"
    :id="iconId"
    data-toggle="tooltip"
    :data-original-title="tooltip"
    :style="dynamicStyle"
    ><slot></slot
  ></i>
</template>
